import { render, staticRenderFns } from "./PackageItem.vue?vue&type=template&id=cd98ac0a&"
import script from "./PackageItem.vue?vue&type=script&lang=ts&"
export * from "./PackageItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports